/**
 * Who may run outbound marketing, in the browser.
 *
 * This is the affordance, not the guarantee — it decides which buttons
 * exist. The refusal that actually stops a send lives in
 * api/_lib/marketing-access.js, which carries the same addresses; the
 * two must agree or the app will offer a button the server rejects.
 */

// The primary address, also named by the Line Review database lock.
export const MARKETING_OWNER_EMAIL = 'mays@paracleteoil.com';

// Both of Mays's work identities in this org.
export const MARKETING_OWNER_EMAILS = new Set([
  MARKETING_OWNER_EMAIL,
  'mays@shadowlandresources.com',
]);

export function isMarketingOwner(user) {
  const email = String(user?.email || '').trim().toLowerCase();
  return !!email && MARKETING_OWNER_EMAILS.has(email);
}

export const MARKETING_RESTRICTED_NOTE =
  'Campaigns are sent by Mays. You can see what has gone out, but not start or change a campaign.';
